export default [{
  "type": "PrivacyManagerUS",
  "name": "U.S. Privacy Manager New",
  "settings": {},
  "children": []
}];